module.exports = __webpack_public_path__ + "img/logo_icon_2.abe00c88.png";